import { render, staticRenderFns } from "./ColorPickerField.vue?vue&type=template&id=6c47dda2&"
import script from "./ColorPickerField.vue?vue&type=script&lang=js&"
export * from "./ColorPickerField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c47dda2')) {
      api.createRecord('6c47dda2', component.options)
    } else {
      api.reload('6c47dda2', component.options)
    }
    module.hot.accept("./ColorPickerField.vue?vue&type=template&id=6c47dda2&", function () {
      api.rerender('6c47dda2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/components/ColorPickerField.vue"
export default component.exports